export const UNBREAKABLE_SEPARATOR = '\u00A0';
